module.exports = __webpack_public_path__ + "img/CM-MS-24-Buick-Modern.4a537699.jpg";